import React from 'react'
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { Button, Col, Container, Row } from 'react-bootstrap'

const HotelBanner = () => {

  const images = [
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351607/Domestic Hotels/Hotels_Coorg/Paddington Resort/pool.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351607/Domestic Hotels/Hotels_Coorg/Paddington Resort/pool.jpg"
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351606/Domestic Hotels/Hotels_Coorg/Paddington Resort/Pool_3.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351606/Domestic Hotels/Hotels_Coorg/Paddington Resort/Pool_3.jpg"
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350155/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_Exterior_2.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350155/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_Exterior_2.jpg"
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350191/Domestic Hotels/Hotels_Coorg/Paddington Resort/Mellow_Glory.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350191/Domestic Hotels/Hotels_Coorg/Paddington Resort/Mellow_Glory.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350167/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350167/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351597/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_balcony.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351597/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_balcony.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350173/Domestic Hotels/Hotels_Coorg/Paddington Resort/Cefe_Lounge.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350173/Domestic Hotels/Hotels_Coorg/Paddington Resort/Cefe_Lounge.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351610/Domestic Hotels/Hotels_Coorg/Paddington Resort/Front.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351610/Domestic Hotels/Hotels_Coorg/Paddington Resort/Front.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350187/Domestic Hotels/Hotels_Coorg/Paddington Resort/Barbeque.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350187/Domestic Hotels/Hotels_Coorg/Paddington Resort/Barbeque.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351549/Domestic Hotels/Hotels_Coorg/Paddington Resort/Bliss_bathroom.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351549/Domestic Hotels/Hotels_Coorg/Paddington Resort/Bliss_bathroom.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350158/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_Exterior.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350158/Domestic Hotels/Hotels_Coorg/Paddington Resort/Rukam_Exterior.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351557/Domestic Hotels/Hotels_Coorg/Paddington Resort/Bliss_Exterior.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351557/Domestic Hotels/Hotels_Coorg/Paddington Resort/Bliss_Exterior.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350169/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_5.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350169/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_5.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350166/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_4.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350166/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_4.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350169/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_3.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350169/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_3.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350166/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_2.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350166/Domestic Hotels/Hotels_Coorg/Paddington Resort/Malenge_2.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351542/Domestic Hotels/Hotels_Coorg/Paddington Resort/Mellow_Glory_Exterior.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460351542/Domestic Hotels/Hotels_Coorg/Paddington Resort/Mellow_Glory_Exterior.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350183/Domestic Hotels/Hotels_Coorg/Paddington Resort/Paripoorna_4.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350183/Domestic Hotels/Hotels_Coorg/Paddington Resort/Paripoorna_4.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350182/Domestic Hotels/Hotels_Coorg/Paddington Resort/Paripoorna_3.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1460350182/Domestic Hotels/Hotels_Coorg/Paddington Resort/Paripoorna_3.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842376/Hotel/Coorg/00060773/5_55qzjH.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842376/Hotel/Coorg/00060773/5_55qzjH.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842389/Hotel/Coorg/00060773/Bliss-Siting_Are_BRE14f.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842389/Hotel/Coorg/00060773/Bliss-Siting_Are_BRE14f.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842411/Hotel/Coorg/00060773/Honeycomb_Joo1El.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842411/Hotel/Coorg/00060773/Honeycomb_Joo1El.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842431/Hotel/Coorg/00060773/MellowGlory_(5)_ty3rsK.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842431/Hotel/Coorg/00060773/MellowGlory_(5)_ty3rsK.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842445/Hotel/Coorg/00060773/Rukum_(1)_Omts3k.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1574842445/Hotel/Coorg/00060773/Rukum_(1)_Omts3k.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v7517603034/Hotel/Coorg/00060773/11_rCmwBf.JPG",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v7517603034/Hotel/Coorg/00060773/11_rCmwBf.JPG",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8286480656/Hotel/00060773/022_Mellow_Glory_K5XD6X.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8286480656/Hotel/00060773/022_Mellow_Glory_K5XD6X.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2459038975/Hotel/00060773/021_Mellow_Glory_O6WhJX.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2459038975/Hotel/00060773/021_Mellow_Glory_O6WhJX.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6008539088/Hotel/00060773/020_Mellow_Glory_OjLXIi.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6008539088/Hotel/00060773/020_Mellow_Glory_OjLXIi.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5633613330/Hotel/00060773/019_Mellow_Glory_QQERMj.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5633613330/Hotel/00060773/019_Mellow_Glory_QQERMj.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3039856567/Hotel/00060773/E_010_Honeycomb_x7dAem.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3039856567/Hotel/00060773/E_010_Honeycomb_x7dAem.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5974591075/Hotel/00060773/E_011_Honeycomb_50euH9.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5974591075/Hotel/00060773/E_011_Honeycomb_50euH9.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6814900419/Hotel/00060773/E_009_Honeycomb_H4lWaE.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6814900419/Hotel/00060773/E_009_Honeycomb_H4lWaE.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0900920525/Hotel/00060773/E_008_Honeycomb_LxYm2w.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0900920525/Hotel/00060773/E_008_Honeycomb_LxYm2w.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5681951277/Hotel/00060773/E_023_Bliss_qfULFT.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5681951277/Hotel/00060773/E_023_Bliss_qfULFT.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6900320500/Hotel/00060773/E_024_Bliss_2bq5CR.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6900320500/Hotel/00060773/E_024_Bliss_2bq5CR.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8156452191/Hotel/00060773/E_025_Bliss_QWSU6k.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8156452191/Hotel/00060773/E_025_Bliss_QWSU6k.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v7221123591/Hotel/00060773/E_026_Bliss_V6RzuF.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v7221123591/Hotel/00060773/E_026_Bliss_V6RzuF.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5935288446/Hotel/00060773/E_001_Euphoria_G8qXq3.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5935288446/Hotel/00060773/E_001_Euphoria_G8qXq3.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0460119010/Hotel/00060773/E_002_Euphoria_XiGcZT.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0460119010/Hotel/00060773/E_002_Euphoria_XiGcZT.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3384484323/Hotel/00060773/E_003_Euphoria_lDmVXK.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3384484323/Hotel/00060773/E_003_Euphoria_lDmVXK.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5746235146/Hotel/00060773/E_004_Euphoria_fYPE1U.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5746235146/Hotel/00060773/E_004_Euphoria_fYPE1U.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v9319105540/Hotel/00060773/E_051_Euphoria_Vvy4m1.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v9319105540/Hotel/00060773/E_051_Euphoria_Vvy4m1.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3990378578/Hotel/00060773/E_031_Pathway_1hK9Ay.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3990378578/Hotel/00060773/E_031_Pathway_1hK9Ay.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v9004438707/Hotel/00060773/Calista_Jacuzzi_Bathroom_v6wTpV.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v9004438707/Hotel/00060773/Calista_Jacuzzi_Bathroom_v6wTpV.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1874067087/Hotel/00060773/Calista_Bedroom_1GWuko.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1874067087/Hotel/00060773/Calista_Bedroom_1GWuko.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0820707442/Hotel/00060773/Calista_Leaving_Room_GuxUIs.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0820707442/Hotel/00060773/Calista_Leaving_Room_GuxUIs.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6672615008/Hotel/00060773/Calista_Individual_Pool_Villa_rvTdN6.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6672615008/Hotel/00060773/Calista_Individual_Pool_Villa_rvTdN6.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0296412678/Hotel/00060773/Calista_Private_Pool_Villas_4D7jV0.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0296412678/Hotel/00060773/Calista_Private_Pool_Villas_4D7jV0.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6792210099/Hotel/00060773/012_Restaurant_C5I7i2.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6792210099/Hotel/00060773/012_Restaurant_C5I7i2.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3071778501/Hotel/00060773/013_Restaurant_IfxDVi.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3071778501/Hotel/00060773/013_Restaurant_IfxDVi.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4431614008/Hotel/00060773/014_Restaurant_MRUU1C.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4431614008/Hotel/00060773/014_Restaurant_MRUU1C.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8638507150/Hotel/00060773/E_005_Lobbi_K47YqN.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8638507150/Hotel/00060773/E_005_Lobbi_K47YqN.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4517795247/Hotel/00060773/E_006_Lobbi_ehDJLe.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4517795247/Hotel/00060773/E_006_Lobbi_ehDJLe.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0390168224/Hotel/00060773/E_27_spa_new_dbjK0T.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0390168224/Hotel/00060773/E_27_spa_new_dbjK0T.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5110322056/Hotel/00060773/E_028_Spa_ykz0g2.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5110322056/Hotel/00060773/E_028_Spa_ykz0g2.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5372180720/Hotel/00060773/E_029_Pathway_ulcOrc.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5372180720/Hotel/00060773/E_029_Pathway_ulcOrc.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2878781604/Hotel/00060773/E_030_Pathway_OiDvnu.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2878781604/Hotel/00060773/E_030_Pathway_OiDvnu.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2257330796/Hotel/00060773/E_031_Pathway_2ev0iT.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v2257330796/Hotel/00060773/E_031_Pathway_2ev0iT.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3763630484/Hotel/00060773/E_051_Euphoria_Db7PFj.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v3763630484/Hotel/00060773/E_051_Euphoria_Db7PFj.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6874289940/Hotel/00060773/E_052_W2o6oA.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v6874289940/Hotel/00060773/E_052_W2o6oA.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0696222510/Hotel/00060773/E_WB9A1938_edited_2_9QWWRx.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v0696222510/Hotel/00060773/E_WB9A1938_edited_2_9QWWRx.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8372436308/Hotel/00060773/WB9A1877_8_9_edited_6paA7U.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v8372436308/Hotel/00060773/WB9A1877_8_9_edited_6paA7U.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1291363459/Hotel/00060773/WB9A1895_6_7_edited_uapY5S.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1291363459/Hotel/00060773/WB9A1895_6_7_edited_uapY5S.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1896924302/Hotel/00060773/WB9A1910_1_2_edited_wy73NQ.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v1896924302/Hotel/00060773/WB9A1910_1_2_edited_wy73NQ.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4098199060/Hotel/Coorg/00060773/76A8ADCC33D4493A9F5BC94919567493_Jz3aj6.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v4098199060/Hotel/Coorg/00060773/76A8ADCC33D4493A9F5BC94919567493_Jz3aj6.jpg",
      },
      {
        original: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5030809882/Hotel/00060773/E_050_Euphoria_08SP4O.jpg",
        thumbnail: "https://imgcld.yatra.com/ytimages/image/upload/t_hotel_mobileactualimage/v5030809882/Hotel/00060773/E_050_Euphoria_08SP4O.jpg",
      }
  ];
  
  return (

    <div className="galleryslider">
        <Container>
            <div className="sliderBox">
                <ImageGallery items={images} slideOnThumbnailOver={true}/>
            </div>
        </Container>
    </div>
  );
}

export default HotelBanner
